export function SET_DISTRIBUTOR_SELECTED(state, distributor) {
  state.distributorSelected = distributor;
}

export function SET_USER_TO_UPDATE(state, user) {
  state.userSelected = user;
}
